// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"332":"1e7c11c9","354":"8f07dfb9","838":"2981e5b4"}[chunkId] + ".js";
};